import { render, staticRenderFns } from "./LeaveAlert.vue?vue&type=template&id=c638d9fe&scoped=true&"
import script from "./LeaveAlert.vue?vue&type=script&lang=ts&"
export * from "./LeaveAlert.vue?vue&type=script&lang=ts&"
import style0 from "./LeaveAlert.vue?vue&type=style&index=0&id=c638d9fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c638d9fe",
  null
  
)

export default component.exports